module.exports = "mutation ($id: ID!) {\n  PostDelete(id: $id) {\n    id\n  }\n}\n"